var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          staticClass: "item-card",
          staticStyle: {
            "border-radius": "4px !important",
            border: "1px solid #dee5ec",
          },
          attrs: { shadow: "never", "body-style": "margin: 0px;" },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "table-hover",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.shippingData,
                "show-header": false,
                "row-class-name": "table-hover",
                "cell-class-name": "table-hover",
                "highlight-current-row": false,
              },
              on: { "expand-change": _vm.expandRow },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "margin-left": "60px" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-row",
                              staticStyle: { margin: "0px 12px 8px 0px" },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "font-weight": "500" } },
                                [
                                  _vm._v(
                                    "\n                Shipped on:\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-left": "2px" } },
                                [
                                  _c("time-zone-formatter", {
                                    attrs: {
                                      "output-format": "MMM DD, YYYY",
                                      "current-time": props.row.shipping_date,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "shipment-current-status-full" },
                            [
                              _c("strong", [_vm._v("Current Status:")]),
                              _vm._v(
                                " " +
                                  _vm._s(props.row.current_status) +
                                  "\n              "
                              ),
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "shipment-current-status-full-last-update",
                                },
                                [
                                  _vm._v(
                                    "Last Updated: " +
                                      _vm._s(
                                        props.row.current_status_timestamp ||
                                          "N/A"
                                      )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-row",
                              staticStyle: { margin: "0px 12px 8px 0px" },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "font-weight": "500" } },
                                [
                                  _vm._v(
                                    "\n                Estimated arrival:\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-left": "2px" } },
                                [
                                  _c("time-zone-formatter", {
                                    attrs: {
                                      "output-format": "MMM DD, YYYY",
                                      "current-time":
                                        props.row.estimated_arrival_date,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-row",
                              staticStyle: { margin: "0px 8px 8px 0px" },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "\n                Items Shipped\n              "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { id: "order-details-item" } },
                            _vm._l(
                              props.row.shipment_items,
                              function (item, idx) {
                                return _c(
                                  "shipping-details",
                                  _vm._b(
                                    {
                                      key: idx,
                                      staticStyle: { "margin-bottom": "8px" },
                                      attrs: {
                                        "shipment-data":
                                          props.row.shipment_items[idx],
                                      },
                                    },
                                    "shipping-details",
                                    item,
                                    false
                                  )
                                )
                              }
                            ),
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "shipment_provider" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("strong", [
                          _vm._v(_vm._s(scope.row.shipping_provider)),
                        ]),
                        _c("br"),
                        _vm._v("\n          Track ID: "),
                        scope.row.track_id
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://www.swiship.com/track/?id=" +
                                    scope.row.track_id,
                                  target: "_blank",
                                },
                              },
                              [_vm._v(_vm._s(scope.row.track_id))]
                            )
                          : _c("span", [
                              _vm._v(
                                "\n            No information\n          "
                              ),
                            ]),
                        _vm._v(" "),
                        scope.row.current_status && !scope.row.expanded
                          ? _c(
                              "el-tag",
                              {
                                staticClass: "shipment-current-status",
                                attrs: { type: "primary" },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.current_status) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }